import clsx from 'clsx';

import useSchedulerRestrictions from '@/utils/hooks/swr/scheduler/useSchedulerRestrictions';
import useDeviceToken from '@/utils/hooks/swr/useDeviceToken';
import useSocialProfilePermissions from '@/utils/hooks/swr/useSocialProfilePermissions';
// Hooks
import useTeamMembers from '@/utils/hooks/swr/useTeamMembers';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';
import { useNewFunnelActivated } from '@/utils/scheduler/funnel/hooks/useNewFunnelActivated';

import PropTypes from 'prop-types';

import { PERMISSIONS } from '@/lib/permissions/socialPermissions';
// Lib
import { FACEBOOK, LINKEDIN, THREADS, TWITTER, X } from '@/lib/socialProfile';

// Components
import Loader from '@/components/base/Loader';

import SchedulerPermissionModal from './restrictAccessModals/SchedulerPermissionModal';

export const schedulerPermissionModalNetworks = [FACEBOOK, TWITTER, X, LINKEDIN, THREADS];

export const ModalRestrictionPage = ({ activeSocialProfile, hasSchedulerPermission }) => {
    const { isNewFunnel } = useNewFunnelActivated();

    if (isNewFunnel) {
        return null;
    }

    if (
        !hasSchedulerPermission &&
        schedulerPermissionModalNetworks.includes(activeSocialProfile?.social_network_type)
    ) {
        return <SchedulerPermissionModal />;
    }

    return null;
};

ModalRestrictionPage.propTypes = {
    hasSchedulerPermission: PropTypes.bool.isRequired
};

const SchedulerAccessRights = ({ children, isFullHeight = false, className }) => {
    const { activeSocialProfile } = useActiveSocialProfile();
    // Use for select when we create/edit a post
    useSchedulerRestrictions();
    useTeamMembers();

    const { isLoading: isLoadingDeviceToken } = useDeviceToken();
    const { permissions, isLoading: isLoadingPermissions } = useSocialProfilePermissions(
        activeSocialProfile?.id
    );

    if (isLoadingDeviceToken || isLoadingPermissions) {
        return (
            <div className="flex h-full items-center justify-center">
                <Loader className="h-7 w-7 text-icoBlue" />
            </div>
        );
    }

    return (
        <div
            className={clsx('relative flex flex-col', className, {
                'min-h-[calc(100%+18px)]': isFullHeight
            })}>
            {children({
                hasSchedulerPermission: permissions?.includes(PERMISSIONS.SCHEDULER),
                shouldBlockView:
                    !permissions?.includes(PERMISSIONS.SCHEDULER) &&
                    schedulerPermissionModalNetworks.includes(
                        activeSocialProfile?.social_network_type
                    )
            })}
        </div>
    );
};

SchedulerAccessRights.propTypes = { className: PropTypes.string };

export default SchedulerAccessRights;
